
import { useState, useEffect, useRef } from 'react';

const testimonials = [
  {
    name: 'Sarah Mitchell',
    location: 'Toorak',
    avatar: 'https://public.readdy.ai/ai/img_res/84a76a886576381b0f93bfe2f33a8795.jpg',
    rating: 5,
    title: 'Spotless Every Single Time',
    review:
      'The team transformed our home after renovation. Every corner was immaculate, and they even cleaned areas we forgot to mention. Absolutely brilliant service — been using James Cleaning for 3 years now.',
    service: 'Deep Cleaning',
    isRegular: true,
  },
  {
    name: 'James Chen',
    location: 'Richmond',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20young%20asian%20man%20with%20short%20dark%20hair%20smiling%20confidently%2C%20warm%20natural%20lighting%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=avatar-james-02&orientation=squarish',
    rating: 5,
    title: 'Got My Full Bond Back',
    review:
      'Was stressed about my end-of-lease clean but James Cleaning made it effortless. The property manager was impressed. Worth every dollar — highly recommend for anyone moving in Melbourne.',
    service: 'Move-in/Move-out',
    isRegular: false,
  },
  {
    name: 'Emma Rodriguez',
    location: 'Brighton East',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20young%20woman%20with%20dark%20curly%20hair%20and%20warm%20smile%2C%20natural%20soft%20lighting%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=avatar-emma-03&orientation=squarish',
    rating: 5,
    title: '10 Out of 10 Would Recommend',
    review:
      'We have the fortnightly regular clean and it has been a game changer for our family. The team is always punctual, friendly, and thorough. Our Melbourne home has never looked better.',
    service: 'Regular Cleaning',
    isRegular: true,
  },
  {
    name: 'David Park',
    location: 'South Yarra',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20middle%20aged%20man%20with%20glasses%20and%20short%20hair%20smiling%20warmly%2C%20natural%20lighting%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=avatar-david-04&orientation=squarish',
    rating: 5,
    title: 'Professional & Thorough',
    review:
      'I run a small office in South Yarra and James Cleaning keeps it spotless. Their attention to detail is unmatched. The team of 5 is incredibly efficient — they finish fast without cutting corners.',
    service: 'Regular Cleaning',
    isRegular: true,
  },
  {
    name: 'Lisa Thompson',
    location: 'Hawthorn',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20an%20older%20woman%20with%20short%20grey%20hair%20and%20kind%20smile%2C%20warm%20natural%20lighting%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=avatar-lisa-05&orientation=squarish',
    rating: 5,
    title: 'Like Having a New Home',
    review:
      'After 10 years in our Hawthorn home, things had built up. James Cleaning did a deep clean that made everything feel brand new. The kitchen and bathrooms were absolutely gleaming.',
    service: 'Deep Cleaning',
    isRegular: false,
  },
  {
    name: 'Michael Wong',
    location: 'Doncaster',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20young%20man%20with%20neat%20dark%20hair%20and%20friendly%20smile%2C%20natural%20lighting%20neutral%20background%2C%20high%20quality%20portrait%20photography&width=100&height=100&seq=avatar-michael-06&orientation=squarish',
    rating: 5,
    title: 'Best in Melbourne Suburbs',
    review:
      "Living out in Doncaster, I wasn\'t sure they\'d service our area — but they do! Reliable, affordable, and the results speak for themselves. Our go-to cleaners for over 2 years.",
    service: 'Regular Cleaning',
    isRegular: true,
  },
];

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex gap-0.5">
      {Array.from({ length: 5 }).map((_, i) => (
        <i
          key={i}
          className={`ri-star-fill text-sm ${i < rating ? 'text-amber-400' : 'text-gray-200'}`}
        ></i>
      ))}
    </div>
  );
}

function TestimonialCard({
  testimonial,
  index,
  isVisible,
}: {
  testimonial: typeof testimonials[0];
  index: number;
  isVisible: boolean;
}) {
  return (
    <div
      className={`bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg hover:-translate-y-1 transition-all duration-500 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
      style={{ transitionDelay: isVisible ? `${index * 100}ms` : '0ms' }}
    >
      {testimonial.isRegular && (
        <span className="inline-block bg-teal-50 text-teal-700 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full mb-4">
          Regular Client
        </span>
      )}
      <StarRating rating={testimonial.rating} />
      <h3 className="font-bold text-gray-900 mt-3 mb-2 text-base">{testimonial.title}</h3>
      <p className="text-gray-600 text-sm leading-relaxed mb-5">{testimonial.review}</p>
      <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
        <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
          <img
            src={testimonial.avatar}
            alt={testimonial.name}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="min-w-0">
          <p className="font-semibold text-gray-900 text-sm">{testimonial.name}</p>
          <p className="text-gray-500 text-xs">
            {testimonial.location} &middot; {testimonial.service}
          </p>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="testimonials" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">
              Testimonials
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-3">
              Trusted by Melbourne Families
            </h2>
            <p className="text-gray-500 text-base max-w-xl">
              Over 10 years of delivering spotless results across Melbourne and its suburbs.
              Here&apos;s what our clients have to say.
            </p>
          </div>
          <div className="flex items-center gap-6 flex-shrink-0">
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600">4.9</div>
              <div className="flex text-amber-400 text-sm mt-1">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-half-fill"></i>
              </div>
              <p className="text-gray-500 text-xs mt-1">Average Rating</p>
            </div>
            <div className="w-px h-12 bg-gray-200"></div>
            <div className="text-center">
              <div className="text-3xl font-bold text-teal-600">2,000+</div>
              <p className="text-gray-500 text-xs mt-1">Happy Homes</p>
            </div>
          </div>
        </div>

        {/* Testimonial Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, idx) => (
            <TestimonialCard
              key={idx}
              testimonial={testimonial}
              index={idx}
              isVisible={isVisible}
            />
          ))}
        </div>

        {/* Trust badges */}
        <div
          className={`mt-14 flex flex-wrap justify-center items-center gap-8 transition-all duration-700 delay-700 ${
            isVisible ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="flex items-center gap-2 text-gray-400">
            <i className="ri-shield-check-line text-xl"></i>
            <span className="text-sm font-medium">Fully Insured</span>
          </div>
          <div className="flex items-center gap-2 text-gray-400">
            <i className="ri-user-follow-line text-xl"></i>
            <span className="text-sm font-medium">Background Checked</span>
          </div>
          <div className="flex items-center gap-2 text-gray-400">
            <i className="ri-leaf-line text-xl"></i>
            <span className="text-sm font-medium">Eco-Friendly Products</span>
          </div>
          <div className="flex items-center gap-2 text-gray-400">
            <i className="ri-map-pin-2-line text-xl"></i>
            <span className="text-sm font-medium">Melbourne & All Suburbs</span>
          </div>
        </div>
      </div>
    </section>
  );
}
